import { Component, OnInit } from '@angular/core';
import { fadeInOut } from '../../animations';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  // animations : [fadeInOut(300)],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  showSpinner;
  spinnerMessage;

  constructor(private service: SpinnerService) {
    this.service.spinnerState.subscribe(state => {
      this.showSpinner = state.show;
      this.spinnerMessage = state.message;
    });
  }

  ngOnInit() {}
}
